import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import { RequireFeature } from '@/features/authentication';
import { LazyLoad } from '@/shared/components/LazyLoad';

const AiControlPage = lazy(() => import('./pages/AiControlPage'));

/**
 * `/ai-control` (2026-10-30): each procurement category's supplier-evaluation weightage. Guarded by the feature the
 * sidebar entry names, so a menu entry that appears is a URL that opens -- the arrangement `workflowConfigRoute` uses.
 */
export const aiControlRoute: RouteObject = {
  path: 'ai-control',
  element: (
    <RequireFeature feature="AI Control">
      <LazyLoad>
        <AiControlPage />
      </LazyLoad>
    </RequireFeature>
  ),
};
